import React, { useState, useEffect } from 'react';

import AuthenticatedComponent from '../AuthenticatedComponent';
import ApartmentService from '../../services/ApartmentService.js';
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import "react-datepicker/dist/react-datepicker.css";
import CreateApartmentComponent from './subcomponents/CreateApartmentComponent';
import ApartmentTableRowComponent from './subcomponents/ApartmentTableRowComponent';



function Apartments() {
    const navigate = useNavigate();
    const _apartments = useSelector(state => state.apartments._apartments);
    const [report, setReport] = useState([]);

    const addToReportList = (id) => {
        let newReport = [...report];
        newReport.push(id);
        setReport(newReport);
    };

    const removeFromReportList = (id) => {
        let newReport = report.filter(x => x !== id);
        setReport(newReport);
    };

    const requestApartments = () => {
        if (_apartments.length === 0) {
            ApartmentService.getApartments();
        }
    };

    useEffect(() => {
        requestApartments();
    }, []);

    const reportClick = () => {
        navigate("/letter?apartments=" + report.join(","));
    };

    let existingApartments = null;
    if (_apartments) {
        existingApartments = _apartments.map((apartment) => {
            return <ApartmentTableRowComponent key={apartment.id} apartment={apartment} report={report} addToReportList={addToReportList} removeFromReportList={removeFromReportList}></ApartmentTableRowComponent>;
        });
    }

    var createApartmentElement = <CreateApartmentComponent></CreateApartmentComponent>;
    // var createApartmentElement = <React.Fragment></React.Fragment>;
    
    return (
        <div className="container standardBackground">
            <div className="row">
                {createApartmentElement}
            </div>
            <div className="row">
                <div className="col-md">
                    <table id="apartmentsTable" className="table table-responsive"><thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th><button className="btn btn-primary" onClick={reportClick}>Generer Email</button></th>
                            <th></th>
                        </tr>
                        <tr>
                            <th style={{ textAlign: "center" }}>Andels nr.</th>
                            <th className='textAlignLeft'>Adresse</th>
                            <th className='textAlignLeft'>Beboere</th>
                            <th style={{ textAlign: "center" }}>Indkald Venteliste</th>
                            <th style={{ textAlign: "center" }}>Sat til salg</th>
                        </tr>
                    </thead>
                        <tbody>
                            {existingApartments}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default AuthenticatedComponent(Apartments)